<template>
	<div class="min-h-screen flex flex-col sm:justify-center items-center">
		<div>
			<slot name="logo" />
		</div>

		<div class="w-full sm:max-w-md overflow-hidden">
			<slot />
		</div>
	</div>
</template>
